import { axiosRequest } from "../../configs/axios.config";

export class OrganizationDefaultColumnService {
  getAll(success, error) {
    axiosRequest.get(`/organization_default_board_columns`)
      .then(({ data }) => success(data))
      .catch(errorResp => error(errorResp))
  }

  getById(idColumn, success, error) {
    axiosRequest.get(`/organization_default_board_columns/${idColumn}`)
      .then(({ data }) => success(data))
      .catch(errorResp => error(errorResp))
  }

  edit(idColumn, data, success, error) {
    axiosRequest.put(`/organization_default_board_columns/${idColumn}`, data)
      .then(({ data }) => success(data))
      .catch(errorResp => error(errorResp))
  }

  create(data, success, error) {
    axiosRequest.post('/organization_default_board_columns', data)
      .then(({ data }) => success(data))
      .catch(errorResp => error(errorResp))
  }

  delete(idColumn, success, error) {
    axiosRequest.delete(`/organization_default_board_columns/${idColumn}`)
      .then(({ data }) => success(data))
      .catch(errorResp => error(errorResp))
  }
}